import React, { useEffect, useState } from "react";
import "./InfoCours.css";
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";

import imCours from "../../../Assets/cap-js.JPG";
import { useParams } from "react-router-dom";
import { getDocument } from "../../../Firebase";
import { SamaDate } from "../../../Services";
import MonBtn from "../Btnbtn/MonBtn";
export default function InfoCours() {
  const { id } = useParams();
  const [details, setDetails] = useState({})
  
  useEffect(() => {
    getDocument("cours", id, setDetails)
  }, [])

  return (
    <div id="infoCours">
      <h2 className="text-center"> Information du cours</h2>
      <Container>
        <Row>
          <Col lg={8} className='mx-auto'>
            <div className="container-img  ">
              <iframe
                src={details?.lien_cours}
                title="YouTube video player"
                frameborder="0"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                allowfullscreen
              ></iframe>
            </div>
          </Col>
          <Col lg={4} className="d-lg-flex align-items-center">
            <div>
              <p className="fs-2">
                <span> titre :</span>
                {details?.titre_cours}
              </p>
              <p>
                Ajouté par <span className="fw-bold ">{details.infoUser} <param name="" value="" /></span>  <br />
                Ajouté le <span className="fw-bold "> <SamaDate mydate={details?.created_on} /> </span>  <br />
              </p>
              <p>Nombre de suivis : <span className="fw-bold text-danger">{details?.etudiants?.length} </span> </p>
              <div className="d-flex  ">
                <MonBtn>Mes Cours</MonBtn>
              </div>
            </div>
          </Col>
        </Row>
      </Container>
    </div>
  );
}
